import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AllContent } from '../../types';
import AllContentDetailsList from '../AllContentDetailsList/AllContentDetailsList';

import { useTranslatedContent } from '../../hooks/useTranslatedContent';
import styles from './Dropdown.module.less';
import DropdownHeader from './DropdownHeader/DropdownHeader';


interface DropdownProps {
  isOpen: boolean;
  onClose: () => void;
  items: AllContent[];
  groupByCategory?: boolean;
  onItemRemove?: (itemId: number | string) => void;
  showHeader?: boolean;
  fullWidth?: boolean;
}

const Dropdown: React.FC<DropdownProps> = ({
  showHeader = true,
  isOpen,
  onClose,
  items,
  groupByCategory = false,
  onItemRemove,
  fullWidth = false,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { getTranslation } = useTranslatedContent();


  const groupedItems = React.useMemo(() => {
   
    const categorized: Record<string, AllContent[]> = {};
    const uncategorized: AllContent[] = [];
    
    
    items.forEach(item => {
      const category = item.category?.translations?.[0]?.category_name || t('uncategorized');
      
      if (category === t('uncategorized')) {
        uncategorized.push(item);
      } else {
        if (!categorized[category]) categorized[category] = [];
        categorized[category].push(item);
      }
    });
    
   
    return {
      [t('uncategorized')]: uncategorized,
      ...categorized
    } as Record<string, AllContent[]>;
  }, [items, t]);

  const handleItemClick = (item: AllContent) => {
    const categorySlug = item.category?.slug || 'uncategorized';
    const itemSlug = item.slug;
    const path = `/${categorySlug}/${itemSlug}`;

    navigate(path);
    onClose();
  };


  if (!isOpen) return null;

  const hasItems = Object.keys(groupedItems).length > 0;


  return (
    <>
      <div
        className={`${styles.dropdown} ${showHeader ? styles.showHeader : ''} ${fullWidth ? styles.full : ''}`}
      >
        {showHeader && <DropdownHeader value="savedContent" />}

        <div className={`${hasItems ? styles.dropdownContent : ''}`}>
          {Object.entries(groupedItems).map(([category, categoryItems]) => (
            <div key={category} className={styles.categoryGroup}>
              {groupByCategory &&  category !== "Uncategorized" &&
(
                <h4 className={styles.categoryTitle}>
                  { categoryItems && getTranslation(categoryItems[0].category, 'category_name') }
                </h4>
              )}
              {categoryItems.map((item) => (
                <div key={item.id} className={styles.contentItem}>
                  <h5
                    className={styles.contentTitle}
                    onClick={() => handleItemClick(item)}
                  >
                    {getTranslation(item, 'title') || 'Untitled'}
                  </h5>
                  <AllContentDetailsList
                    content={item}
                    className={styles.courseDetails}
                    itemClassName={styles.courseDetailsItem}
                    showTags={true}
                    iconClass={styles.iconClass}
                  />
                  {onItemRemove && (
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onItemRemove(item.id);
                      }}
                      className={`${styles.removeButton} ${styles.removeButton__border}`}
                    >
                      {t('Delete')}
                    </button>
                  )}
                  <button
                    className={styles.removeButton}
                    onClick={() => handleItemClick(item)}
                  >
                    {t('View')}
                  </button>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Dropdown;
